import React, { MouseEvent, CSSProperties, useRef, useMemo } from 'react';
import cl from 'classnames';
import styles from './buttonStyle.module.scss';

const copyIcon = (
  <svg
    width="37"
    height="35"
    viewBox="0 0 37 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.icon}
  >
    <ellipse
      cx="18.4211"
      cy="17.5"
      rx="18.4211"
      ry="17.5"
      fill="white"
      fillOpacity="0.13"
    />
    <path
      d="M24.3996 15.5996H17.1996C16.316 15.5996 15.5996 16.316 15.5996 17.1996V24.3996C15.5996 25.2833 16.316 25.9996 17.1996 25.9996H24.3996C25.2833 25.9996 25.9996 25.2833 25.9996 24.3996V17.1996C25.9996 16.316 25.2833 15.5996 24.3996 15.5996Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4 20.4H11.6C11.1757 20.4 10.7687 20.2314 10.4686 19.9314C10.1686 19.6313 10 19.2243 10 18.8V11.6C10 11.1757 10.1686 10.7687 10.4686 10.4686C10.7687 10.1686 11.1757 10 11.6 10H18.8C19.2243 10 19.6313 10.1686 19.9314 10.4686C20.2314 10.7687 20.4 11.1757 20.4 11.6V12.4"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const printIcon = (
  <svg
    width="37"
    height="35"
    viewBox="0 0 37 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.icon}
  >
    <ellipse
      cx="18.4211"
      cy="17.5"
      rx="18.4211"
      ry="17.5"
      fill="white"
      fillOpacity="0.13"
    />
    <path
      d="M12.6 22.4008H10.8C10.3226 22.4008 9.86477 22.2111 9.52721 21.8736C9.18964 21.536 9 21.0782 9 20.6008V16.1008C9 15.6234 9.18964 15.1656 9.52721 14.828C9.86477 14.4904 10.3226 14.3008 10.8 14.3008H25.2C25.6774 14.3008 26.1352 14.4904 26.4728 14.828C26.8104 15.1656 27 15.6234 27 16.1008V20.6008C27 21.0782 26.8104 21.536 26.4728 21.8736C26.1352 22.2111 25.6774 22.4008 25.2 22.4008H23.4"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.4016 18.8008H12.6016V26.0008H23.4016V18.8008Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6016 14.3V8H23.4016V14.3"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const downloadIcon = (
  <div className={cl(styles.downloadIcon, styles.icon)}>
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25 7.5L9 11.25L12.75 7.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 11.25L9 2.25"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 11.25V14.25C15.75 14.6478 15.592 15.0294 15.3107 15.3107C15.0294 15.592 14.6478 15.75 14.25 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V11.25"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);

const exportToXlsxIcon = (
  <div className={cl(styles.downloadIcon, styles.icon)}>
    <svg
      width="22"
      height="22"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_118)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.25 2.18254V22.8175C6.25 24.0228 7.21189 25 8.39844 25H22.8516C24.0381 25 25 24.0228 25 22.8175V5.74318C25 5.16017 24.7704 4.6014 24.3624 4.19143L20.8186 0.630791C20.4164 0.226664 19.8735 0 19.3078 0H8.39844C7.21189 0 6.25 0.977156 6.25 2.18254ZM7.61719 22.8175V2.18254C7.61719 1.74422 7.96697 1.38889 8.39844 1.38889H19.043V6.15079C19.043 6.97265 19.6988 7.63889 20.5078 7.63889H23.6328V22.8175C23.6328 23.2558 23.283 23.6111 22.8516 23.6111H8.39844C7.96697 23.6111 7.61719 23.2558 7.61719 22.8175ZM23.6328 6.25V5.74318C23.6328 5.53118 23.5493 5.32799 23.4009 5.1789L20.4102 2.17386V6.15079C20.4102 6.20558 20.4539 6.25 20.5078 6.25H23.6328Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0156 10.2539C16.0156 9.87637 16.3217 9.57031 16.6992 9.57031H21.1914C21.5689 9.57031 21.875 9.87637 21.875 10.2539C21.875 10.6314 21.5689 10.9375 21.1914 10.9375H16.6992C16.3217 10.9375 16.0156 10.6314 16.0156 10.2539Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0156 13.3789C16.0156 13.0014 16.3217 12.6953 16.6992 12.6953H21.1914C21.5689 12.6953 21.875 13.0014 21.875 13.3789C21.875 13.7564 21.5689 14.0625 21.1914 14.0625H16.6992C16.3217 14.0625 16.0156 13.7564 16.0156 13.3789Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0156 16.5039C16.0156 16.1264 16.3217 15.8203 16.6992 15.8203H21.1914C21.5689 15.8203 21.875 16.1264 21.875 16.5039C21.875 16.8814 21.5689 17.1875 21.1914 17.1875H16.6992C16.3217 17.1875 16.0156 16.8814 16.0156 16.5039Z"
          fill="white"
        />
        <path
          d="M0 7.22656C0 6.57935 0.524666 6.05469 1.17188 6.05469H12.8906C13.5378 6.05469 14.0625 6.57935 14.0625 7.22656V18.9453C14.0625 19.5925 13.5378 20.1172 12.8906 20.1172H1.17187C0.524666 20.1172 0 19.5925 0 18.9453V7.22656Z"
          fill="white"
        />
        <path
          d="M3.90625 17.009L6.10123 12.9234L4.10919 9.17969H5.62592L6.91299 11.6951L8.17337 9.17969H9.67407L7.68204 12.9822L9.87701 17.009H8.31223L6.88629 14.3013L5.46036 17.009H3.90625Z"
          fill="#1F93FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_118">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
);

const exportToPdfIcon = (
  <div className={cl(styles.downloadIcon, styles.icon)}>
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.24115 9.22302C5.24115 8.73832 4.90458 8.44904 4.31063 8.44904C4.06834 8.44904 3.90419 8.4724 3.81812 8.49583V10.0523C3.91988 10.0754 4.04498 10.0833 4.21655 10.0833C4.85024 10.0833 5.24115 9.76273 5.24115 9.22302Z"
        fill="#FFFFFF"
      />
      <path
        d="M8.91752 8.46466C8.65135 8.46466 8.47971 8.48809 8.37769 8.51155V11.96C8.47952 11.9838 8.64376 11.9838 8.79239 11.9838C9.87138 11.9914 10.5752 11.3974 10.5752 10.1383C10.5831 9.04309 9.9417 8.46466 8.91752 8.46466Z"
        fill="#FFFFFF"
      />
      <path
        d="M15.9616 6.43852H15.5294V4.35303C15.5294 4.34002 15.5273 4.32692 15.5256 4.31375C15.5249 4.23094 15.4986 4.1496 15.4419 4.08516L11.9714 0.120719C11.9703 0.119706 11.9693 0.119346 11.9686 0.118235C11.9479 0.0951305 11.9238 0.0759149 11.8983 0.0592809C11.8908 0.0542156 11.8831 0.0499672 11.8752 0.0455881C11.8531 0.0335293 11.8297 0.0235294 11.8056 0.0163072C11.7991 0.0144771 11.7932 0.0117974 11.7866 0.010098C11.7604 0.00388888 11.7332 0 11.7056 0H3.17647C2.78699 0 2.47058 0.316764 2.47058 0.705914V6.43835H2.03846C1.4813 6.43835 1.02954 6.88992 1.02954 7.44727V12.6938C1.02954 13.2508 1.4813 13.7027 2.03846 13.7027H2.47062V17.2941C2.47062 17.6832 2.78702 18 3.1765 18H14.8235C15.2127 18 15.5294 17.6832 15.5294 17.2941V13.7027H15.9616C16.5186 13.7027 16.9705 13.2508 16.9705 12.6938V7.44744C16.9705 6.89012 16.5186 6.43852 15.9616 6.43852ZM3.17647 0.706044H11.3527V4.31757C11.3527 4.51257 11.5109 4.67051 11.7056 4.67051H14.8235V6.43875H3.17647V0.706044ZM11.8418 10.0988C11.8418 11.1078 11.4744 11.8035 10.9653 12.2338C10.4107 12.6952 9.56596 12.914 8.53407 12.914C7.91642 12.914 7.47861 12.8749 7.1811 12.836V7.65897C7.61897 7.58874 8.19018 7.54963 8.79234 7.54963C9.79273 7.54963 10.4419 7.72963 10.9505 8.11257C11.4976 8.51926 11.8418 9.16819 11.8418 10.0988ZM2.63725 12.8594V7.65897C3.0046 7.59675 3.52097 7.54963 4.24823 7.54963C4.98323 7.54963 5.50728 7.69041 5.85904 7.97211C6.19538 8.23783 6.42162 8.67583 6.42162 9.19198C6.42162 9.70828 6.25005 10.1462 5.93702 10.4431C5.53042 10.8264 4.92836 10.9985 4.22437 10.9985C4.06823 10.9985 3.92699 10.9906 3.818 10.9749V12.8596H2.63725V12.8594ZM14.8235 17.103H3.17647V13.7027H14.8235V17.103H14.8235ZM15.8463 8.56623H13.8205V9.7705H15.7131V10.7402H13.8205V12.8595H12.6247V7.58874H15.8463V8.56623Z"
        fill="#FFFFFF"
      />
    </svg>
  </div>
);

export type ButtonProps = {
  label: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  size?: 'small' | 'middle';
  design:
    | 'link'
    | 'backLink'
    | 'blue'
    | 'lightBlue'
    | 'lightPurple'
    | 'white'
    | 'pink'
    | 'outline'
    | 'outlineBlue';
  icon?: 'copy' | 'print' | 'download' | 'exportToXlsx' | 'exportToPdf';
  className?: string;
  labelContainerClassName?: string;
  labelClassName?: string;
  autoSize?: boolean;
  style?: CSSProperties;
  tabIndex?: number;
  countIndicator?: number;
  isCountChanged?: boolean;
} & Partial<React.ButtonHTMLAttributes<HTMLButtonElement>>;

export const Button = ({
  label,
  onClick,
  size = 'middle',
  design,
  icon,
  className,
  labelContainerClassName,
  labelClassName,
  autoSize = false,
  style,
  tabIndex = -1,
  countIndicator = 0,
  isCountChanged = false,
  ...otherProps
}: ButtonProps) => {
  const ref = useRef<HTMLButtonElement | null>(null);
  const withIndicator = useMemo(
    () => Boolean(countIndicator || isCountChanged),
    [countIndicator, isCountChanged],
  );

  return (
    <button
      onClick={(event) => {
        onClick?.(event);
        ref.current?.blur();
      }}
      ref={ref}
      className={cl(
        styles.button,
        styles[design],
        size === 'small' && styles.small,
        autoSize && styles.autoSize,
        icon && styles.withIcon,
        className,
      )}
      type="button"
      style={style}
      tabIndex={tabIndex}
      {...otherProps}
    >
      <div
        className={cl(
          styles.labelContainer,
          withIndicator && styles.withIndicator,
          labelContainerClassName,
        )}
      >
        {design === 'backLink' && (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19 12H5"
              stroke="#1F93FF"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 19L5 12L12 5"
              stroke="#1F93FF"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {icon === 'copy' && copyIcon}
        {icon === 'print' && printIcon}
        {icon === 'download' && downloadIcon}
        {icon === 'exportToXlsx' && exportToXlsxIcon}
        {icon === 'exportToPdf' && exportToPdfIcon}
        <div className={cl(styles.label, labelClassName)}>{label}</div>
      </div>
      {withIndicator && (
        <div className={cl(styles.indicator, isCountChanged && styles.changed)}>
          {countIndicator}
        </div>
      )}
    </button>
  );
};

export default Button;
